<template>
  <a href="#" class="btn back-to-top btn-secondary bg-dark-transparent btn-round" @click="anchorSoftAnimation" v-appear>
    <svg class="icon" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>{{ $t('action.back_to_top') }}</title>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polygon points="0 0 24 0 24 24 0 24" opacity="0"></polygon>
        <rect fill="#FFFFFF" x="11" y="5" width="2" height="14" rx="1"></rect>
        <path d="M6.70710678,12.7071068 C6.31658249,13.0976311 5.68341751,13.0976311 5.29289322,12.7071068 C4.90236893,12.3165825 4.90236893,11.6834175 5.29289322,11.2928932 L11.2928932,5.29289322 C11.6714722,4.91431428 12.2810586,4.90106866 12.6757246,5.26284586 L18.6757246,10.7628459 C19.0828436,11.1360383 19.1103465,11.7686056 18.7371541,12.1757246 C18.3639617,12.5828436 17.7313944,12.6103465 17.3242754,12.2371541 L12.0300757,7.38413782 L6.70710678,12.7071068 Z" fill="#FFFFFF" fill-rule="nonzero"></path>
      </g>
    </svg>
  </a>
</template>

<script>
import animationsMixin from '@/mixins/animations'

export default {
  mixins: [ animationsMixin ],
  name: 'backToTop',
  directives: {
    appear: {
      // directive definition
      inserted (el) {
        window.jQuery(window).scroll(() => {
          if (document.documentElement.scrollTop > 913) {
            window.jQuery(el).css({ opacity: 1 })
          } else {
            window.jQuery(el).css({ opacity: 0 })
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.btn.back-to-top {
  opacity: 0;
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 1020;
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
